import { useAtom } from 'jotai'
import { getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_sdModelThemeOptions } from '~/graphqls/types'
import {
  cfgAtom,
  cfgScale1Atom,
  cfgScale2Atom,
  choasAtom,
  clipSkipAtom,
  cutDiffProportionAtom,
  ensdAtom,
  paintTimesAtom,
  paintTimesStepAtom,
  selectSamplerAtom,
  styleDecorationAtom,
  styleAtom,
  tagCategoryIdAtom,
} from './atom'
import { isNullOrUndefined } from '~/utils'

export function useSetDefaultPaintParams() {
  const [, setSelectSampler] = useAtom(selectSamplerAtom)
  const [, setCfg] = useAtom(cfgAtom)
  const [, setEnsd] = useAtom(ensdAtom)
  const [, setClipSkip] = useAtom(clipSkipAtom)
  const [, setPaintTimes] = useAtom(paintTimesAtom)
  const [, setPaintTimesStep] = useAtom(paintTimesStepAtom)
  const [, setTagCategoryId] = useAtom(tagCategoryIdAtom)
  const [, setStyleDecoration] = useAtom(styleDecorationAtom)
  const [, setCutDiffProportion] = useAtom(cutDiffProportionAtom)
  const [, setCfgScale1] = useAtom(cfgScale1Atom)
  const [, setCfgScale2] = useAtom(cfgScale2Atom)
  const [, setStyle] = useAtom(styleAtom)
  const [, setChaos] = useAtom(choasAtom)

  return (
    item: Partial<getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_sdModelThemeOptions>
  ) => {
    setCfg(item?.cfg ?? undefined)
    setSelectSampler(
      isNullOrUndefined(item?.samplerIndex) ? undefined : [item?.samplerIndex!]
    )
    setEnsd(item?.ensd ?? undefined)
    setClipSkip(item?.clipSkip ?? undefined)
    setTagCategoryId(item?.tagModelLinkId)
    setPaintTimes(item?.generateNum ?? 1)
    setPaintTimesStep(item?.generateNum ?? 1)
    // if (!!item.defaultSelectStyleDecorationOption?.length) {
    //   setStyleDecoration(item?.defaultSelectStyleDecorationOption as any)
    // } else {
    //   setStyleDecoration([])
    // }
    setCutDiffProportion(item?.cutdiffProportion ?? undefined)
    setCfgScale1(item?.cfgScale1 ?? undefined)
    setCfgScale2(item?.cfgScale2 ?? undefined)
    setStyle(item?.flux?.style ?? 100)
    setChaos(item?.flux?.chaos ?? 40)
  }
}
